import React, { memo, useRef, Fragment, forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import DropdownIndicator from '~/core/scripts/components/CustomReactSelect/DropdownIndicator';
import ClearIndicator from '~/core/scripts/components/CustomReactSelect/ClearIndicator';
import SearchPresets from '~/core/scripts/components/SearchPresets';

import '../CustomReactSelect/CustomReactSelect.styl';
import './ListSearch.styl';

const ListSearch = memo(
  forwardRef((props, ref) => {
    const selectNode = ref || useRef(null);

    const handleSelect = (resultItem) => props.onSelect(resultItem);

    const onPresetClick = (preset) => {
      const matchingItem = props.data.find(
        (d) =>
          d[props.searchPresetsFieldName] ===
          preset[props.searchPresetsFieldName]
      );

      if (!matchingItem) {
        return console.log('List search preset: no matching item found.');
      }

      selectNode.current.select.setValue(matchingItem);
    };

    return (
      <Fragment>
        <ReactSelect
          ref={selectNode}
          labelKey={props.fieldName}
          placeholder={props.placeholder}
          noOptionsMessage={() => props.notFoundMessage}
          options={props.data}
          isClearable
          getOptionValue={(option) => option[props.fieldName]}
          getOptionLabel={(option) => option[props.fieldName]}
          value={props.value}
          onChange={(option) => handleSelect(option)}
          className="react-select__wrap"
          classNamePrefix="react-select"
          components={{
            ClearIndicator,
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#4C80BC', // blue50
              primary75: '#83B0E5', // blue65
              primary50: '#A4C8F1', // blue75
              primary25: '#C9E2FF', // blue85
            },
          })}
        />
        <SearchPresets
          presets={props.searchPresets.map((p) => ({
            ...p,
            name: p[props.searchPresetsFieldName],
          }))}
          onClick={(p) => onPresetClick(p)}
          title={props.searchPresetsTitle}
        />
      </Fragment>
    );
  })
);

ListSearch.displayName = 'ListSearch';

ListSearch.propTypes = {
  fieldName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  maxItems: PropTypes.number,
  minChars: PropTypes.number,
  onSelect: PropTypes.func,
  notFoundMessage: PropTypes.string,
  placeholder: PropTypes.string,
  searchPresets: PropTypes.array,
  searchPresetsTitle: PropTypes.string,
  searchPresetsFieldName: PropTypes.string,
};

ListSearch.defaultProps = {
  data: [],
  maxItems: 5,
  minChars: 0,
  onSelect: () => {},
  notFoundMessage: 'Keine Einträge gefunden',
  placeholder: 'Geben Sie etwas ein...',
  searchPresets: [],
  searchPresetsFieldName: 'name',
};

export default ListSearch;
